import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api";
import { LineGraphData, RevenueChartData, TrendDataPoint } from "./types";

export const fetchDashboardAnalytics = createAsyncThunk(
    "dashboard/fetchAnalytics",
    async (_, { rejectWithValue }) => {
      try {
        const response = await api.get("/admin/dashboard-analytics/performance-metrics");
        return response.data.data;
      } catch (error: any) {
        if (error.response) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  
  export const fetchLineGraphData = createAsyncThunk(
    "dashboard/fetchInteractiveGraphData",
    async (params: { startDate?: string; endDate?: string }, { rejectWithValue }) => {
      try {
        const response = await api.get("/admin/dashboard-analytics/interactive-trend-graph", { params });
        const data = response.data.data;
  
        const formatLabel = (label: string, period: string) => {
          if (period === 'weekly' && /^\d{4}-\d{2}-\d{2}$/.test(label)) {
              const date = new Date(label);
              return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
          }
          return label;
        }
  
        const downloads: TrendDataPoint[] = data.data.map((d: any) => ({
          name: formatLabel(d.label, data.period),
          value: d.downloads,
        }));
  
        const subscriptions: TrendDataPoint[] = data.data.map((d: any) => ({
          name: formatLabel(d.label, data.period),
          value: d.subs,
        }));
  
        const result: LineGraphData = {
          period: data.period,
          range: data.range,
          totalDownloads: data.overallDownloads,
          totalSubs: data.overallSubs,
          downloads,
          subscriptions,
        };
        return result;
      } catch (error: any) {
        if (error.response) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );
  
  export const fetchRevenueChartData = createAsyncThunk(
    'dashboard/fetchRevenueChartData',
    async (params: { startDate?: string; endDate?: string; }, { rejectWithValue }) => {
      try {
        const response = await api.get("admin/dashboard-analytics/revenue-bar-graph", { params });
        const chartData = response.data.data;
  
        const formatLabel = (label: string, period: string) => {
            if (period === 'weekly' && /^\d{4}-\d{2}-\d{2}$/.test(label)) {
                const date = new Date(label);
                return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short' });
            }
            return label;
        }
  
        const transformedData: RevenueChartData = {
            period: chartData.period,
            range: chartData.range,
            overallRevenue: chartData.overallRevenue,
            data: chartData.data.map((item : any) => ({
                name: formatLabel(item.label, chartData.period),
                value: item.revenue
            }))
        };
        return transformedData;
      } catch (error: any) {
        if (error.response) {
          return rejectWithValue(error.response.data);
        }
        return rejectWithValue({ message: "An unexpected error occurred" });
      }
    }
  );

  export const fetchUsers = createAsyncThunk('userTable/fetchUsers', async (params: { page?: number; limit: number; search?: string; status?: string }, { rejectWithValue }) => {
    try {
        const { page, limit, search, status } = params;
        const response = await api.get('/user-management/fishnity-accounts', {
            params: {
                page,
                limit,
                search: search || undefined,
                status: status === 'all' ? undefined : status,
            }
        });
        return response.data.data;
    } catch (error: any) {
        return rejectWithValue(error.response.data);
    }
});
  